import { Image } from 'antd';
import satellite from '../../res/img/login/satelite.png';
import RegisterForm from '../../components/Organisms/CommonForm/CommonForm';
import './UserRegister.less';
/**
 * @component UserRegister.tsx
 * @description Component for the Invap register.
 * @return { page }
 */
function UserRegister() {
  return (
    <div className="org-register__container">
      <div className="org-register__left-half">
        <div className="org-register-logo-green" />
        <RegisterForm
          isRegister={true}
          forgotPassword={false}
          successMessage={() => {}}
        />
      </div>
      <div className="org-register__right-half">
        <Image
          width={400}
          src={satellite}
          preview={false}
          className="org-register__image"
        />
      </div>
    </div>
  );
}

export default UserRegister;
